// assets
import SettingOutlined from '@ant-design/icons/SettingOutlined';

// icons
const icons = { SettingOutlined };

// ==============================|| MENU ITEMS - SETTINGS ||============================== //

const settings = {
  id: 'group-settings',
  title: 'Platform',
  type: 'group',
  children: [
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false
    }
  ]
};

export default settings;
